import React, { useEffect, useRef } from 'react';

const MDCSelect = ({
  label,
  name,
  id,
  options = [],
  defaultValue = '',
  className = '',
  onChange,
  ...props
}) => {
  const ref = useRef(null);

  useEffect(() => {
    const el = $(ref.current);
    el.on('change.select2 select2:select', onChange);
    return () => {
      el.off('change.select2 select2:select', onChange);
    };
  }, [onChange]);

  return (
    <div className="pm-flex pm-flex-col">
      <div className="pm-select">
        <label htmlFor={id}>{label}</label>
        <select
          ref={ref}
          name={name}
          id={id}
          defaultValue={defaultValue}
          className={`pm-default-select2-menu mdc-select pm-select-small ${className}`}
          {...props}
        >
          {options.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default MDCSelect;
